module.exports = __webpack_public_path__ + "img/menu_button_playnow_normal_cn.51a595da.png";